import { render } from "./PagerItem.vue?vue&type=template&id=2141b1a2&scoped=true"
import script from "./PagerItem.vue?vue&type=script&lang=js"
export * from "./PagerItem.vue?vue&type=script&lang=js"

import "./PagerItem.vue?vue&type=style&index=0&id=2141b1a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2141b1a2"]])

export default __exports__